"use client";

import classNames from "classnames";
import { FC, ReactNode } from "react";
import {
    COLLAPSE_HEIGHT_HOOK_DEFAULT_TRANSITION_DURATION,
    useCollapseHeight,
} from "@finbackoffice/site-core";
import styles from "./promo-info-panel.module.sass";

type IProps = {
    renderHeader: ReactNode;
    text: ReactNode;
    collapsable?: boolean;
    wrapperClassname?: string;
};

const PromoInfoPanel: FC<IProps> = ({
    renderHeader,
    text,
    wrapperClassname,
    collapsable = false,
}) => {
    const { opened, headerRef, containerRef } = useCollapseHeight(
        true,
        COLLAPSE_HEIGHT_HOOK_DEFAULT_TRANSITION_DURATION,
        collapsable,
    );

    return (
        <div
            className={classNames(
                styles.info,
                opened && styles.opened,
                wrapperClassname && wrapperClassname,
            )}>
            <div className={styles.infoHeader} ref={collapsable ? headerRef : undefined}>
                {collapsable && <i className={styles.arrow} />}
                {renderHeader}
            </div>
            <div className={styles.infoContent} ref={containerRef}>
                {text}
            </div>
        </div>
    );
};

export default PromoInfoPanel;
